import './SplashScreen.scss';

const SplashScreen = () => (
	<div className="SplashScreen">
		<div className="center-blur" />
	</div>
);

export default SplashScreen;
